module.exports = __webpack_public_path__ + "static/media/businesses-icon-3.24648601.svg";